import { Link } from "react-router-dom";
import Reveal from "@/components/site/Reveal";
import { EXHIBITION_IMAGES } from "@/data/content";
import { useT, useRoute } from "@/i18n";

export default function ExhibitionsTeaser() {
  const t = useT();
  const route = useRoute();
  return (
    <section className="bg-[#fafafa] border-y border-black/5">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <Reveal className="order-2 lg:order-1 flex flex-col justify-center px-6 md:px-10 lg:px-20 py-24 lg:py-32">
          <p className="eyebrow">{t.exhibitionsTeaser.eyebrow}</p>
          <h2 className="heading-display mt-4 text-5xl sm:text-6xl lg:text-7xl uppercase">
            {t.exhibitionsTeaser.title1}
            <br />
            <span className="text-[#C20E1A]">{t.exhibitionsTeaser.title2}</span>
          </h2>
          <p className="mt-8 text-lg text-black/75 leading-relaxed max-w-xl">
            {t.exhibitionsTeaser.body}
          </p>
          <div className="mt-10">
            <Link
              to={route("exhibitions")}
              data-testid="exhibitions-discover-btn"
              className="bg-[#C20E1A] text-white px-9 py-4 text-[11px] uppercase tracking-[0.25em] font-bold hover:bg-black transition-colors duration-500 inline-block"
            >
              {t.exhibitionsTeaser.cta}
            </Link>
          </div>
        </Reveal>

        <div className="order-1 lg:order-2 relative h-[60vh] lg:h-auto min-h-[480px] overflow-hidden group">
          <img
            src={EXHIBITION_IMAGES[2]}
            alt="Exhibition"
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1800ms] ease-out group-hover:scale-105"
          />
        </div>
      </div>
    </section>
  );
}
